/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1BannerBrandsQueryResponse,
  GetApiV1BannerBrands401,
  GetApiV1BannerBrands500,
} from "../../types/bannerRegistroController/GetApiV1BannerBrands.ts";

function getGetApiV1BannerBrandsUrl() {
  const res = { method: "GET", url: `/api/v1/banner/brands` as const };
  return res;
}

/**
 * @description Retorna todas as marcas ativas ordenadas por nome para uso como filtro na seleção de turmas. **(Requer Authorization para autenticação)**
 * @summary Listar marcas para seleção no banner (Requer Authorization para autenticação)
 * {@link /api/v1/banner/brands}
 */
export async function getApiV1BannerBrands(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1BannerBrandsQueryResponse,
    ResponseErrorConfig<GetApiV1BannerBrands401 | GetApiV1BannerBrands500>,
    unknown
  >({
    method: "GET",
    url: getGetApiV1BannerBrandsUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
